import { createSlice, PayloadAction } from "@reduxjs/toolkit";
//import { connectByEthereumProvider } from "services/wallet";
import { IWallet } from "types/wallet";

export const initialState: IWallet = {
  address: "",
  connectMethod: null,
  balance: 0,
  network: 0,
  error: null,
  status: "DISCONNECTED",
  isConnectProcessActive: false,
};

export const walletSlice = createSlice({
  name: "wallet",
  initialState,
  reducers: {
    connectWalletSuccess(state, action: PayloadAction<any>) {
      return { ...state, ...action.payload };
    },
    connectWalletFailure(state, action: PayloadAction<string>) {
      alert(action);
    },
    endWalletConnecting(state) {
      alert("Wallet Not Connected");
    },
    resetWalletState(state) {
      localStorage.setItem("LAST_CONNECTED_WALLET", "");
      return { ...state, ...initialState };
    },
    updateWalletAddress(state, action: PayloadAction<string>) {
      state.address = action.payload;  // Update the wallet address in the state
    },
  },
});

// Action creators are generated for each case reducer function
export const { actions: walletActions } = walletSlice;

export default walletSlice.reducer;
